import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery } from "@/services/api";
import { IDropdown } from "@/constants/default";
import { ListResponse } from "@/types/response.type";
import { Company, CompanyForm } from "@/types/company.type";

export const companyApi = createApi({
  reducerPath: "companyApi",
  baseQuery,
  tagTypes:['companies'],
  endpoints: (builder) => ({
    getCompanies: builder.query<ListResponse<Company>, {}>({
      query: (data) => ({ url: `company`, params: data }),
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: ListResponse<Company> }, meta) => {
        return rawResult.data
      },
    }),
    getDropDownCompanies: builder.query<IDropdown[], {}>({
      query: () => ({ url:  `company/dropdown` }),
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: IDropdown[] }, meta) => {
        return rawResult.data
      },
    }),
    getCompany: builder.query<Company, string>({
      query: (id) => `company/${id}`,
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: Company }, meta) => {
        return rawResult.data
      },
    }),
    addCompany: builder.mutation<any, CompanyForm>({
      query: (body) => ({
        url: 'companies',
        method: 'POST',
        body,
      })
    }),
    editCompany: builder.mutation<Company, Pick<Company, "id">>({
      query: ({ id, ...body }) => ({
        url: `company/${id}`,
        method: 'PUT',
        body,
      })
    }),
    deleteCompany: builder.mutation<any, string>({
      query: (id) => ({
        url: `company/${id}`,
        method: 'DELETE',
      })
    }),
  }),
});

export const {useGetDropDownCompaniesQuery} = companyApi